/*eslint-disable*/
import React, { useState, useEffect ,useRef} from 'react';
import { Tabs, Row, Table, Button, Form, Input, Select, Switch, Checkbox, Spin, InputNumber, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined,HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';//props传参检查库
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import trans from './translation';
import Message from '../../component/message/message';
import './sysRole.css';
const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;

const SysRole = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [funcList, setFuncList] = useState([]);
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [deleteTipText, setDeleteTipText] = useState("");
    const tableColumns = {
        roleCode: "role_code",
        roleName: "role_name",
        dispSeq: "disp_seq"
    }

    useEffect(() => {
        search(pageSize, 1, "N");
    },[]);

    const search = (pageSizeNew, current, flag, isShowMsg) => {
        if(Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        clearSelect();//清除選中狀態
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("role/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                } 
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchAllFunc = () => {
        setIsLoading(true);
        Base.callBackApi("role/searchAllFunc").then((data) => {
            if ("SUCCESS" === data.msg) {
                setFuncList(data.object);
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model =>{
            return {...model,...{[key]:value}};
        });
    }
    
    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if(key === "2") {
                if(checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if(Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if(tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({ activeInd: 'Y' });
        searchAllFunc();
        setFlag("add");
        setTabIndex("2");
    }

    const update = (model, e) => {
        messageShowHandler();
        e.stopPropagation();
        setIsLoading(true);
        Base.callBackApi("role/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let roleModel = data.object;
                initForm(roleModel);
                setCheckboxState([roleModel]);
                setSelectedRowKeys([roleModel.roleId]);
                setFlag("edit");
                setTabIndex("2");
                setFuncList(roleModel.funcList);
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }


    const edit = () => {
        messageShowHandler();
        if(!selectedRowKeys || selectedRowKeys.length !== 1) {
            errFrameShow("error", trans.selectiveData[Config.backLang]);
            return;
        }
        let model = checkboxState[0];
        initForm(model);
        setIsLoading(true);
        Base.callBackApi("role/searchRoleFunc", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setFlag("edit");
                setTabIndex("2");
                setFuncList(data.object);
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            roleCode: model.roleCode ?? "",
            roleName: model.roleName ?? "",
            activeInd: model.activeInd ?? "",
            dispSeq: model.dispSeq ?? "",
            remark: model.remark ?? "",
            funcType:model.funcType ?? "",
        });
    }

    const deleteFrameClose = (state) => {
        if(state) {
            deleteData();
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = checkboxState[0];
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("role/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                cancel();
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
                props.searchMenu(Config.userInfo.role);//刷新menu
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model ,e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let list = [];
        for (let item of funcList) {
            if (item.children != null) {
                for (let iterator of item.children) {
                    list.push(iterator);
                    if (Base.isNotEmpty(iterator.children)) {
                        for (let subFunc of iterator.children) {
                            list.push(subFunc);
                        }
                    }
                }
            }
            list.push(item);
        }
        values.funcList = list;
        let url = "";
        if(flag === "add") {
            url = "role/insert";
        } else {
            url = "role/update"
            values.roleId = selectedRowKeys[0];
            values.lastUpdatedDate = checkboxState[0].lastUpdatedDate;
        }
        values.menuFuncId = Config.funcInfo.funcId;
        values.roleCode = values.roleCode.toLocaleUpperCase();
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById({roleId: data.object})
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false);
            props.searchMenu(Config.userInfo.role);
        });
    }

    const searchById = (model,isDelete) => {
        setIsLoading(true);
        Base.callBackApi("role/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let roleModel = data.object;
                setCheckboxState([roleModel]);
                setSelectedRowKeys([roleModel.roleId]);
                if(isDelete){
                    setDeleteTipText(trans.roleCode2[Config.backLang] +":" + model.roleCode)
                    setIsDeleteFrame(true);
                    return
                }
                initForm(roleModel);
                setFlag("edit");
                setFuncList(roleModel.funcList);
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setTabIndex("1");
        setFuncList([]);
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if(state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        searchById(model,true);
    }

    const checkboxChange = (record, index, flag, value) => {
        if (value) {
            record[flag] = "Y";
            if (flag === "activeInd" && Base.isEmpty(record.children)) {
                record['canSelect'] = "Y";
                record['canInsert'] = "Y";
                record['canUpdate'] = "Y";
                record['canDelete'] = "Y";
                record['canAudit'] = "Y";
                record['canView'] = "Y";
                record['canUpload'] = "Y";
                record['canDownload'] = "Y";
            }
        } else {
            record[flag] = "N"
            if (flag === "activeInd" && Base.isEmpty(record.children)) {
                record['canSelect'] = "N";
                record['canInsert'] = "N";
                record['canUpdate'] = "N";
                record['canDelete'] = "N";
                record['canAudit'] = "N";
                record['canView'] = "N";
                record['canUpload'] = "N";
                record['canDownload'] = "N";
            }
        }
        setFuncList(JSON.parse(JSON.stringify(funcList)));
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }
    
    /*eslint-disable*/
    const columns = [
        {
            title: trans.roleCode2[Config.backLang],
            dataIndex: 'roleCode',
            className: 'tableWidth20',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'roleCode') },
        },
        {
            title: trans.roleName[Config.backLang],
            dataIndex: 'roleName',
            className: 'tableWidth20',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'roleName') },
        },
        {
            title: trans.remark[Config.backLang],
            dataIndex: 'remark',
            className: 'tableWidth35',
        },
        {
            title: trans.jHActiveInd[Config.backLang],
            dataIndex: 'activeInd',
            className: 'tableWidth15',
            render: (text) => ContextHandler.getMapValueTransalation('indsTransalation', text)
        },
        {
            title: trans.dispSeq[Config.backLang],
            dataIndex: 'dispSeq',
            className: 'tableWidth10',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'dispSeq') },
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            width: 206,
            className: ' sysControls',
            fixed: 'right',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record,e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];
    const funcColumns = [
        {
            title: trans.funcName[Config.backLang],
            dataIndex: Config.backLang === "SC" ? "funcName" : (Config.backLang === "TC" ? "funcNameTc" : "funcNameEn" ),
            className: "tableWidth20",
        },
        {
            title: trans.type[Config.backLang],
            dataIndex: 'type',
            className: "tableWidth12",
            render: (text) => ContextHandler.getMapValueTransalation('funcTypeMap', text)
        },
        {
            title: trans.activeInd[Config.backLang],
            dataIndex: 'activeInd',
            className: "tableWidth10",
            render: (text, record, index) => {
                return (
                    <Switch checked={text === "Y"} onChange={(e) => checkboxChange(record, index, "activeInd", e)} />
                );
            }
        },
        {
            title: trans.controls[Config.backLang],
            className: "tableWidth58 sysControls",
            sorter: (a, b) => { return Base.sortMethod(a, b, 'dispSeq') },
            render: (text, record, index) => {
                return (
                    Base.isNotEmpty(record.children) || record.type === "MENU" ? "" :
                        <>
                            <Checkbox key="canSelect" checked={record.canSelect == "Y"} onChange={(e) => checkboxChange(record, index, "canSelect", e.target.checked)}>{trans.search[Config.backLang]}</Checkbox>
                            <Checkbox key="canInsert" checked={record.canInsert == "Y"} onChange={(e) => checkboxChange(record, index, "canInsert", e.target.checked)}>{trans.add2[Config.backLang]}</Checkbox>
                            <Checkbox key="canUpdate" checked={record.canUpdate == "Y"} onChange={(e) => checkboxChange(record, index, "canUpdate", e.target.checked)}>{trans.update[Config.backLang]}</Checkbox>
                            <Checkbox key="canDelete" checked={record.canDelete == "Y"} onChange={(e) => checkboxChange(record, index, "canDelete", e.target.checked)}>{trans.delete[Config.backLang]}</Checkbox>
                            <Checkbox key="canAudit" checked={record.canAudit == "Y"} onChange={(e) => checkboxChange(record, index, "canAudit", e.target.checked)}>{trans.audit2[Config.backLang]}</Checkbox>
                            <Checkbox key="canView" checked={record.canView == "Y"} onChange={(e) => checkboxChange(record, index, "canView", e.target.checked)}>{trans.view[Config.backLang]}</Checkbox>
                            <Checkbox key="canUpload" checked={record.canUpload == "Y"} onChange={(e) => checkboxChange(record, index, "canUpload", e.target.checked)}>{trans.upload[Config.backLang]}</Checkbox>
                            <Checkbox key="canDownload" checked={record.canDownload == "Y"} onChange={(e) => checkboxChange(record, index, "canDownload", e.target.checked)}>{trans.download[Config.backLang]}</Checkbox>
                        </>

                )
            }
        },
    ];
    /*eslint-enable*/

    return (
        <div id="container" className="template sysRole">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.sysManage[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText}/> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">{trans.roleCode2[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.roleCode2[Config.backLang]} value={searchModel.roleCode || ''}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('roleCode', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">{trans.roleName[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.roleName[Config.backLang]} value={searchModel.roleName || ''}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('roleName', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1400 }}
                                    rowKey="roleId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                      //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,                           //默认当前页为1
                                        size:"small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.role[Config.backLang]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.roleCode2[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="roleCode"
                                                rules={[
                                                    { required: true, message: trans.roleCode2IsNoNull[Config.backLang] },
                                                ]}
                                                getValueFromEvent={(e) => Base.codeChange(e, 50)}
                                            >
                                                <Input type="text" placeholder={trans.roleCode2[Config.backLang]} maxLength={50} disabled={flag === "edit"}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.roleName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="roleName"
                                                rules={[
                                                    { required: true, message: trans.roleNameIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.roleName[Config.backLang]} maxLength={50}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.jHActiveInd[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="activeInd"
                                                rules={[
                                                    { required: true, message: trans.jHActiveIndIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className='sysSelect'>
                                                    <Option value=""></Option>
                                                    {context.indsTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.dispSeq[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="dispSeq"
                                                rules={[
                                                    { required: true, validator: (rule, value) => Base.checkNbrOrNull(value, null, 999999999) },
                                                ]}
                                            >
                                                <InputNumber placeholder={trans.dispSeq[Config.backLang]} precision={0} maxLength={9} className="sysRoleInputNumber"/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div> <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.operation[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="funcType"
                                            >
                                                <Select className='sysSelect'>
                                                    <Option value=""></Option>
                                                    {context.funcType.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysColMax'>
                                        <div className="sysParam">{trans.remark[Config.backLang]}</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="remark"
                                            >
                                                <TextArea className="textarea" placeholder={trans.remark[Config.backLang]} maxLength={30} rows = {3}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <Row className="sysRoleBodyRow TabsTwo">
                                    {funcList ? 
                                        <Table
                                            scroll={{x: 1200}}
                                            rowKey="funcId"
                                            defaultExpandAllRows={true}
                                            style={{ width: "100%" }}
                                            loading={{ spinning: isLoading, tip: trans.Loading[Config.backLang]}}
                                            columns={funcColumns} //列名
                                            dataSource={funcList} //数据
                                            pagination={false}
                                        />
                                        : ""
                                    }
                                </Row>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    )

}

SysRole.propTypes = {
    searchMenu: PropTypes.func.isRequired,
}

export default SysRole;